import React from "react";

import Icon from "@/assets/images/icons";
import BrandModal from "@/common/Modal/BrandModal";
import Text from "@/common/Text/Text";
import { Button } from "antd";
import styles from "./ReleaseSendProductionModal.module.scss";

interface Props {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  currentVersion: string;
  nextVersion: string;
  appType?: "krosskast" | "assistant" | "player";
}

const ReleaseSendProductionModal: React.FC<Props> = ({
  open,
  onCancel,
  onConfirm,
  currentVersion,
  nextVersion,
  appType = "assistant",
}) => {
  return (
    <BrandModal
      title="Are you sure you want to send this APK to Production?"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <div className={styles.container}>
        <Text type="title" size="md" className={styles.subtitle}>
          Production APK
        </Text>

        <div className={styles.versionContainer}>
          <div className={styles.versionRow}>
            <Text type="text" size="md" className={styles.versionText}>
              <span className={styles.versionLabel}>Currently active:</span>
              <span className={styles.versionValue}>
                <Icon
                  name={appType}
                  size={16}
                  useImage
                  className={styles.icon}
                />
                {currentVersion}
              </span>
            </Text>
          </div>

          <div className={styles.versionRow}>
            <Text type="text" size="md" className={styles.versionText}>
              <span className={styles.versionLabel}>Make active:</span>
              <span className={styles.versionValue}>
                <Icon
                  name={appType}
                  size={16}
                  useImage
                  className={styles.icon}
                />
                {nextVersion}
              </span>
            </Text>
          </div>
        </div>

        <Text size="sm" className={styles.description}>
          This will send this APK to Production for approval. Please confirm to
          proceed.
        </Text>

        <Button type="primary" danger onClick={onConfirm}>
          Send to Production
        </Button>
      </div>
    </BrandModal>
  );
};

export default ReleaseSendProductionModal;
